import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=2ffb795f&scoped=true&"
import script from "./Homepage.vue?vue&type=script&lang=js&"
export * from "./Homepage.vue?vue&type=script&lang=js&"
import style0 from "./Homepage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Homepage.vue?vue&type=style&index=1&id=2ffb795f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb795f",
  null
  
)

export default component.exports